import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AreaListPage from '@components/pages/c001/AreaListPage';
import WeeklySchedulePage from '@components/pages/c001/WeeklySchedulePage';
import GroupCompletePage from '@components/pages/c002/GroupCompletePage';
import GroupConfirmPage from '@components/pages/c002/GroupConfirmPage';
import GroupRegisterPage from '@components/pages/c002/GroupRegisterPage';
import LoginPage from '@components/pages/c003/LoginPage';
import EquipmentRequestPage from '@components/pages/c005/EquipmentRequestPage';
import TemporaryReservationCompletePage from '@components/pages/c005/TemporaryReservationCompletePage';
import TemporaryReservationConfirmPage from '@components/pages/c005/TemporaryReservationConfirmPage';
import UsagePurposeRegisterPage from '@components/pages/c005/UsagePurposeRegisterPage';
import SectionSchedulePage from '@components/pages/c006/SectionSchedulePage';
import GroupNewCompletePage from '@components/pages/c007/GroupNewCompletePage';
import GroupNewRegisterPage from '@components/pages/c007/GroupNewRegisterPage';
import AreaInfoDialog from '@components/parts/dialog/AreaInfoDialog';
import EquipmentInfoDialog from '@components/parts/dialog/EquipmentInfoDialog';
import SectionDialog from '@components/parts/dialog/SectionDialog';
import Loading from '@components/parts/Loading';

import ActionWithComponent from './ActionWithComponent';
import HomePage from './HomePage';
import OperationPage from './OperationPage';

const RootPage = () => (
  <div className="root">
    <SectionDialog />
    <AreaInfoDialog />
    <EquipmentInfoDialog />
    <Loading />
    <Routes>
      <Route path="/" element={<HomePage />} />
      {process.env.REACT_APP_EnvironmentName === 'dev' && <Route path="/operation" element={<OperationPage />} />}
      <Route path="c001">
        <Route path="arealist" element={<ActionWithComponent element={<AreaListPage />} />} />
        <Route path="weeklyschedule" element={<ActionWithComponent element={<WeeklySchedulePage />} />} />
      </Route>
      <Route path="c002">
        <Route path="register" element={<ActionWithComponent element={<GroupRegisterPage />} />} />
        <Route path="confirm" element={<ActionWithComponent element={<GroupConfirmPage />} />} />
        <Route path="complete" element={<ActionWithComponent element={<GroupCompletePage />} />} />
      </Route>
      <Route path="c005">
        <Route path="purposeregister" element={<ActionWithComponent element={<UsagePurposeRegisterPage />} />} />
        <Route path="equipmentrequest" element={<ActionWithComponent element={<EquipmentRequestPage />} />} />
        <Route
          path="reservationconfirm"
          element={<ActionWithComponent element={<TemporaryReservationConfirmPage />} />}
        />
        <Route
          path="reservationcomplete"
          element={<ActionWithComponent element={<TemporaryReservationCompletePage />} />}
        />
      </Route>
      <Route path="c006">
        <Route path="sectionschedule" element={<ActionWithComponent element={<SectionSchedulePage />} />} />
      </Route>
      <Route path="c003">
        <Route path="login" element={<ActionWithComponent element={<LoginPage />} />} />
      </Route>
      <Route path="c007">
        <Route path="register" element={<ActionWithComponent element={<GroupNewRegisterPage />} />} />
        <Route path="complete" element={<ActionWithComponent element={<GroupNewCompletePage />} />} />
      </Route>
    </Routes>
  </div>
);

export default RootPage;
